module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    staticClass: "erco-dashboard-headbar p-0",
    attrs: {
      "toggleable": ""
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav-collapse"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('p', {
    staticClass: "navbar-brand mb-0 pb-0 pt-0"
  }, [_vm._v("ERCO "), _c('span', {
    staticClass: "text-warning"
  }, [_vm._v("LSP")])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav-collapse"
    }
  }, [_c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "help-dropdown mr-sm-4",
    attrs: {
      "text": "Hilfe"
    }
  }, [_c('b-dropdown-item', [_c('a', {
    attrs: {
      "href": "https://ercowiki.klickmeister.org/mediawiki/index.php/ERCO:LSP4"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Dokumentation")]), _vm._v(" Zugangsdaten: erco:dvdda\n\t\t\t\t")]), _vm._v(" "), _c('b-dropdown-item', [_vm._v("\n\t\t\t\t\tweitere Fragen und Ideen bitte an "), _c('a', {
    attrs: {
      "href": "mailto:lsp@klickmeister.de"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("lsp@klickmeister.de")])])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "mr-sm-4",
    attrs: {
      "text": _vm.username,
      "right-alignment": ""
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.handleSignoutClick
    }
  }, [_vm._v("Signout")])], 1)], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "placeholder": "Suchbegriff"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4f67aee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoDashboardHeadbar.vue
// module id = 662
// module chunks = 0